
import React, { useContext} from 'react';
import { Dropdown } from 'react-bootstrap';
import { StyleContext } from '../context';
import { DUMMY } from '../helpers/functions';

const SampleSelect = ({
    selectOther = DUMMY("custom input"),
    hideOther = DUMMY("hide other"),
    selectSample = DUMMY("select sample"),
    setCurr = DUMMY("set current option"),
    curr=""
}) => {
    const {samples, variant, type} = useContext(StyleContext)
    const handleMisc = (e) => {
        e.preventDefault()
        setCurr("")
        selectOther()
    }
    return (
        <div align="center">
            <Dropdown onSelect={(e) =>selectSample(e)}>
                <Dropdown.Toggle id="dropdown-custom-components" variant={variant}>
                    {curr || `${type} types`}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    {
                        samples.map((elem) =>
                            <Dropdown.Item
                                key={elem}
                                eventKey={elem}
                                onClick={(e) => {
                                    e.preventDefault()
                                    hideOther()
                                    setCurr(elem)
                                }}>
                                {elem}
                            </Dropdown.Item>)
                    }
                    <Dropdown.Divider />
                    <Dropdown.Item eventKey="other" onClick={handleMisc}>Other</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default SampleSelect;
